<div (click)="handleItemClick()" #candidateDropdownOrigin="rtOverlayOrigin" rt-overlay-origin>
  @if (button()) {
    <rt-button variant="tertiary">
      <span class="candidate-wrapper">
        <rt-avatar
          [type]="candidate().hasAvatar ? 'image' : 'initials'"
          [initials]="candidate().initials"
          [size]="'small'"
          [shape]="'oval'"
          [imageSrc]="candidate().photoThumbUrl"
        />
        <rt-truncate>
          <span> {{ candidate().name }} </span>
        </rt-truncate>
      </span>
    </rt-button>
  } @else {
    @if (!button()) {
      @if (!isCandidateDataVisible) {
        <rt-avatar
          [shape]="'oval'"
          size="small"
          type="icon"
          iconName="visibility-off"
          customIconBackgroundColor="colorAvatarSteelLighter"
          customIconColor="colorIconOnprimaryDefault"
        />
      } @else {
        <rt-avatar
          [rtTooltip]="candidate().name"
          [rtTooltipPosition]="'above'"
          [type]="candidate().hasAvatar ? 'image' : 'initials'"
          [initials]="candidate().initials"
          [size]="'small'"
          [shape]="'oval'"
          [imageSrc]="candidate().photoThumbUrl"
        />
      }
    }
  }
</div>

<ng-template
  #candidateDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [rtConnectedOverlayAutoClose]="false"
  [open]="state.dropdownOpen"
  [hasBackdrop]="true"
  [positions]="dropdownConfig"
  [origin]="candidateDropdownOrigin"
  (backdropClick)="toggleDropdown(false)"
>
  <rt-dropdown>
    <rt-dropdown-item>
      <rt-avatar
        [type]="candidate().hasAvatar ? 'image' : 'initials'"
        [initials]="candidate().initials"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="candidate().photoThumbUrl"
        prefix
      />

      <div layout-vertical>
        <rt-heading>
          <rt-truncate>{{ candidate().name }}</rt-truncate>
        </rt-heading>
        @if (isntAssigned) {
          <span text-italic margin-top-small-x>
            {{ 'app.candidate.not_assigned' | translate }}
          </span>
        }
      </div>
    </rt-dropdown-item>
    <rt-dropdown-item (click)="toggleDropdown(false); showCandidate()">
      {{ 'app.candidate.view_full_profile' | translate }}
    </rt-dropdown-item>
    @if (deletable()) {
      <rt-dropdown-item (click)="toggleDropdown(false); removeClick.emit()">
        {{ 'app.candidate.remove_from_list' | translate }}
      </rt-dropdown-item>
    }
    @if (editable()) {
      <rt-dropdown-item (click)="toggleDropdown(false); editClick.emit()">
        {{ 'app.candidate.change_candidate' | translate }}
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
